import React, { useState, useEffect } from 'react';
import styles from './FirstScreen.module.css';
import heroImg from "../images/נטלי שוורץ מסך מרכזי.webp"; 
import Loader from '../components/loader/Loader';

const HeroSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 950);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    const img = new Image();
    img.src = heroImg;
    img.onload = () => setImageLoaded(true);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  if (!imageLoaded) {
    return <Loader />;
  }

  const handleWhatsAppClick = () => {
    const phone = '972508727802';
    const message = encodeURIComponent('היי נטלי הגעתי מהדף שלך, אשמח לשמוע עוד על..');
    window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
  };

  return (
    <section className={styles.hero}>
      <div className={styles.decorElement3}></div>
      <div className={styles.decorElement4}></div>

      <div className={styles.container}>
        {isMobile ? (
          <>
            <div className={styles.subheadingWrapper}>
              <h2 className={styles.subheading}>
             אם אתה בעל עסק שמרגיש שהשיווק גוזל ממך זמן, אנרגיה ושקט נפשי - הדף הזה בשבילך!
              </h2>
            </div>

            <div className={styles.imageWrapper}>
              <img
                src={heroImg}
                alt="נטלי שוורץ - ניהול סושיאל"
                className={styles.image}
              />
            </div>

            <div className={styles.title}>
             לבנות נוכחות חכמה ברשת שממגנטת לקוחות משלמים ומחזקת את המותג שלך
            </div>
<div className={styles.glassContainer}> <p className={styles.description}> ניהול סושיאל ויצירת תוכן שמביאים לקוחות בצורה עקבית וחכמה, <br className={styles.lineBreak}/> בלי להיות עבד של הרשתות, בלי לבזבז שעות על עריכות ויצירת פוסטים גם אם אתם מפחדים לעמוד מול מצלמה </p> </div>

            <button className={styles.ctaButton} onClick={handleWhatsAppClick}>
              אני רוצה נוכחות ברשתות שתביא לי לקוחות
            </button>
          </>
        ) : (
          <>
            <div className={styles.textContent}>
              <div className={styles.subheadingWrapper}>
                <h2 className={styles.subheading}>
               אם אתה בעל עסק שמרגיש שהשיווק גוזל ממך זמן, אנרגיה ושקט נפשי - הדף הזה בשבילך!
                </h2>
              </div>

              <div className={styles.title}>
                לבנות נוכחות חכמה ברשת שממגנטת לקוחות משלמים ומשאירה אותך בראש שקט
              </div>

     <div className={styles.glassContainer}> <p className={styles.description}> ניהול סושיאל ויצירת תוכן שמביאים לקוחות בצורה עקבית וחכמה, <br className={styles.lineBreak}/> בלי להיות עבד של הרשתות, בלי לבזבז שעות על עריכות ויצירת פוסטים גם אם אתם מפחדים לעמוד מול מצלמה </p> </div>

              <button className={styles.ctaButton} onClick={handleWhatsAppClick}>
                אני רוצה נוכחות ברשתות שתביא לי לקוחות
              </button>
            </div>

            <div className={styles.imageWrapper}>
              <img
                src={heroImg}
                alt="נטלי שוורץ - ניהול סושיאל"
                className={styles.image}
              />
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
